import React from 'react';

import CreateOrderPage from '@/features/orders/pages/create-order.page';

const CreateOrderRoute = () => {
  return <CreateOrderPage />;
};

export default CreateOrderRoute;
